import { DateRange } from 'react-date-range';
import * as React from 'react'
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
 
interface Props {
  setDateRange: (ranges: any) => void
  dateRange: {
    startDate: Date
    endDate: Date
    key: string
  }
  minDate: any
  maxDate: any
}

export class DatePicker extends React.Component<Props> {
  constructor(props: any) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(ranges: any) {
    this.props.setDateRange(ranges)
  }

  render() {
    return (
      <DateRange
        minDate={this.props.minDate}
        maxDate={this.props.maxDate}
        ranges={[this.props.dateRange]}
        onChange={this.props.setDateRange}
      />
    )
  }
}
 